angular.module('main').directive('onloadlogo', () => ({
	restrict: 'AE',
	link(scope, img, attrs) {
		const imgDOM = img[0];

		imgDOM.classList.add('hide');
		img.on('load', e => {
			imgDOM.style.maxHeight = `${imgDOM.naturalHeight / 2}px`;
			imgDOM.style.width = `${imgDOM.naturalWidth / 2}px`;
			imgDOM.classList.remove('hide');
		});
	}
}));



// WEBPACK FOOTER //
// ./web/js/components/onloadlogoComponent.js